import React, { useEffect } from 'react';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Slide from '@mui/material/Slide';
import Zoom from '@mui/material/Zoom';
import { alertStyle, successColor, errorColor, leadingIcon } from './style';

export default function AlertDialog({ message = '', open, setOpen = () => {}, error = false }) {
  useEffect(() => {
    let automaticClose;
    if (open) {
      automaticClose = setTimeout(() => setOpen(false), 1800);
      return automaticClose;
    }
    return () => {
      clearTimeout(automaticClose);
    };
  }, [open]);
  return (
    <Zoom in={open} orientation="horizontal">
      <Alert
        icon={error ? <ErrorIcon sx={leadingIcon} /> : <CheckCircleOutlineIcon sx={leadingIcon} />}
        transition={Slide}
        style={{
          ...alertStyle,
          ...(error ? errorColor : successColor),
        }}
        action={
          <IconButton
            aria-label="close"
            size="small"
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{ mb: 2 }}
      >
        {message}
      </Alert>
    </Zoom>
  );
}
